import { S } from './AlertContent.styles';
import type { AlertContentProps } from './AlertContent.types';

export const AlertContent = (props: AlertContentProps) => <S.Content {...props} />;
